import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getAllowedCountries } from 'services/AllowedCountriesService'
import type { AllowedCountry } from 'types/authentication/Profile'
import { sortCountries } from 'utils/sortCountries'
import { ONE_DAY } from 'utils/utils'

export const useAllowedCountriesQuery = () => {
  return useQuery<AllowedCountry[]>({
    queryKey: reactQueryKeys.allowedCountries(),
    queryFn: () => getAllowedCountries(),
    staleTime: ONE_DAY,
    select: countries => sortCountries(countries),
  })
}
